import { useTranslation } from '@crehana/i18n';
import { PAGE_KEY } from "./constants";
import en from "./locale-en";
import es from "./locale-es";
import pt from "./locale-pt";
var locales = {
  en: en,
  pt: pt,
  es: es
};
export var useInputFilterTranslation = function useInputFilterTranslation() {
  var context = useTranslation(PAGE_KEY);
  return context;
};
export var useAddI18nLocales = function useAddI18nLocales() {
  var _useTranslation = useTranslation(),
    addResourceBundle = _useTranslation.addResourceBundle;
  addResourceBundle(locales);
};